import { Component } from 'react';
import PropTypes from 'prop-types';


export default class VideoPlayer extends Component {
  static propTypes = {
    alt: PropTypes.string,
    innerRef: PropTypes.func,
    onLoadCallback: PropTypes.func,
  };

  state = {
    isLoaded: false,
  };

  componentDidMount() {
    if (this.videoElement && this.state.isLoaded) {
      this.initObserver();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * Чтобы observer работал корректно с видео, необходимо дождаться его полной загрузки,
     * иначе в консоли будут предупреждения, что load блокирует play()
     */
    if (this.videoElement && prevState.isLoaded !== this.state.isLoaded) {
      this.initObserver();
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  /**
   * Так как play является ассинхронной операцией, а сама функция возвращает промис,
   * мы запоминаем его в переменную, чтобы избежать ошибок с тем, что пауза блокирует
   * play и в консоли появляется предупреждение
   */
  playPromise = null;

  initObserver = () => {
    this.observer = new IntersectionObserver(this.updateVisibleState, {
      threshold: [0.5],
    });
    this.observer.observe(this.videoElement);
  };

  updateVisibleState = entries => {
    const firstEntry = entries[0];
    if (firstEntry.intersectionRatio >= 0.5 && !this.playPromise) {
      this.playPromise = this.videoElement
        .play()
        .catch(e => console.error(e));
    } else if (firstEntry.intersectionRatio < 0.5 && this.playPromise) {
      this.playPromise
        .then(() => {
          this.videoElement.pause();
          this.playPromise = null;
        })
        .catch(e => console.error(e));
    }
  };

  setVideoRef = element => {
    const { innerRef } = this.props;

    innerRef && typeof innerRef === 'function' && innerRef(element);
    this.videoElement = element;
  };

  onLoadedData = () => {
    this.setState({
      isLoaded: true,
    });
    this.props.onLoadCallback();
  };

  render() {
    const {
      alt,
      onLoadCallback, // eslint-disable-line
      innerRef, // eslint-disable-line
      ...videoProps
    } = this.props;

    return (
      <video
        muted
        loop
        {...videoProps}
        ref={this.setVideoRef}
        onLoadedData={this.onLoadedData}
      >
        {alt || ''}
      </video>
    );
  }
}
